import React from 'react';

import createStyle from 'shared-utils/src/createStyle';

import Carpark from 'shared-vectors/icons/Carpark';
import Energyclass from 'shared-vectors/icons/Energyclass';
import { Icon } from 'shared-vectors';

import GridItem from '../../../../../GridItem';

import styles, { mainCls } from './style';
import { getPrice } from '../../../../utils';

const useStyles = createStyle(styles);

export default function Features({
  isAuction,
  features,
  isProjectProfile,
  projectData,
  showMortgage,
  showMqPrice,
  isHoliday,
  iosLth12,
}) {
  const cls = useStyles();

  const {
    energyClass,
    level,
    mq,
    parkings,
    parkingOffer,
    rooms,
    price,
    bathrooms,
    includes_property_ownership,
    lastActivity,
    rentPrice,
  } = features;

  const priceEl = getPrice({
    className: `${cls[`${mainCls}--price`]} tp-w--l`,
    price,
    projectData: isProjectProfile ? projectData : null,
    isAuction,
    showMortgage,
    isHoliday,
    showMqPrice,
    mq,
    includes_property_ownership,
  });

  let size = null;
  let roomNum = null;
  let bathNum = null;
  let levelValue = null;
  let parkingNum = null;

  if (isProjectProfile) {
    size = projectData.size;
    roomNum = projectData.rooms;
    parkingNum = projectData.box;
  } else {
    size = mq || null;
    roomNum = rooms || null;
    bathNum = bathrooms || null;
    levelValue = level || null;
    parkingNum = parkings || null;
  }

  return (
    <GridItem behavior="fixed">
      <p className={`${cls[`${mainCls}__text`]} first tp-s--m tp-w--s c-txt--f0`}>
        {isAuction && (
          <span className={`${cls[`${mainCls}__text--auction`]} mr--s tp-s--x2s tp-w--l tp--up`}>
            Asta
          </span>
        )} 
        {priceEl}
      </p>
      <p className={`${cls[`${mainCls}__text`]} ${cls[`${mainCls}__items`]}${iosLth12 ? ` iosLth12` : ''} tp-s--m tp-w--s c-txt--f0`}>
        {size && <span className={cls[`${mainCls}__item`]}>{size} m²</span>}
        {roomNum && <span className={cls[`${mainCls}__item`]}>{roomNum} local{parseInt(roomNum, 10) > 1 ? 'i' : 'e'}</span>}
        {bathNum && <span className={cls[`${mainCls}__item`]}>{bathNum} bagn{parseInt(bathNum, 10) > 1 ? 'i' : 'o'}</span>}
        {levelValue && <span className={cls[`${mainCls}__item`]}>{levelValue}</span>}
        {energyClass && <span className={cls[`${mainCls}__item`]}>{energyClass} <Icon className={cls[`${mainCls}__item--ec`]} name={Energyclass} size="ml" fill /></span>}
        {parkingNum && <span className={cls[`${mainCls}__item`]}>{parkingNum} <Icon className={cls[`${mainCls}__item--cp`]} name={Carpark} size="ml" fill />{parkingOffer.available ? <>&nbsp;(box opzionale{parkingOffer.value ? <>&nbsp;&euro;&nbsp;<span className="tp-w--l">{parkingOffer.value}</span></> : ''})</> : ''}</span>}
        {isProjectProfile && projectData.constructionEndDate && <span className={cls[`${mainCls}__item`]}>{projectData.constructionEndDate}</span>}
        {lastActivity && <span className={cls[`${mainCls}__item`]}>ultima attività {lastActivity.toLowerCase()}</span>}
        {rentPrice && <span className={cls[`${mainCls}__item`]}>affitto <span className="tp-w--l">&euro; {rentPrice}</span>/mese</span>}
      </p>
    </GridItem>
  );
}